import { render, staticRenderFns } from "./MeasureListItemDetailInfo.vue?vue&type=template&id=28a2bbfc&scoped=true"
import script from "./MeasureListItemDetailInfo.vue?vue&type=script&lang=js"
export * from "./MeasureListItemDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./MeasureListItemDetailInfo.vue?vue&type=style&index=0&id=28a2bbfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2bbfc",
  null
  
)

export default component.exports